import "../styles/product.css";
import "../styles/style.css";
import * as THREE from "three";
import * as dat from "dat.gui";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";

/**
 * Debug
 */

console.log();
// const gui = new dat.GUI();

const parameters = {
  materialColor: "#ffeded",
};

// gui.addColor(parameters, "materialColor");

/**
 * Base
 */
// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Models
 */

/**
 * Objects
 */
// Texture
const textureLoader = new THREE.TextureLoader();
const gradientTexture = textureLoader.load("textures/gradients/3.jpg");
gradientTexture.magFilter = THREE.NearestFilter;

// Material
const material = new THREE.MeshToonMaterial({
  color: parameters.materialColor,
  gradientMap: gradientTexture,
});

// Objects
const objectsDistance = 4;

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xebebeb, 0.6);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.2);
directionalLight.position.set(1, -2, 5);
scene.add(directionalLight);

const directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.2);
directionalLight2.position.set(2.3, -0.5, 5);
scene.add(directionalLight2);

const light = new THREE.PointLight(0xffffff, 0.4, 100);
light.position.set(2, 0, 10);
// scene.add(light);

const helper = new THREE.DirectionalLightHelper(directionalLight, 5);
scene.add(helper);

const pointLight = new THREE.PointLight(0xebebeb, 0.4, 5, 2);
pointLight.position.set(1, 1, 1);
scene.add(pointLight);

const sphereSize = 1;
const pointLightHelper = new THREE.PointLightHelper(pointLight, sphereSize);
// scene.add(pointLightHelper);
/**
 * Particles
 */
// Geometry
const particlesCount = 800;
const positions = new Float32Array(particlesCount * 6);
const particleTexture = textureLoader.load("/textures/1.png");

for (let i = 0; i < particlesCount; i++) {
  positions[i * 3 + 0] = (Math.random() - 0.5) * 10;
  positions[i * 3 + 1] =
    objectsDistance * 0.5 - Math.random() * objectsDistance * 7;
  positions[i * 3 + 2] = (Math.random() - 0.5) * 10;
}

const particlesGeometry = new THREE.BufferGeometry();
particlesGeometry.setAttribute(
  "position",
  new THREE.BufferAttribute(positions, 3)
);

// Material
const particlesMaterial = new THREE.PointsMaterial({
  color: parameters.materialColor,
  sizeAttenuation: textureLoader,
  size: 0.03,
});

particlesMaterial.size = 0.05;
particlesMaterial.color = new THREE.Color("#000000");
particlesMaterial.transparent = true;
particlesMaterial.alphaMap = particleTexture;
// Points
const particles = new THREE.Points(particlesGeometry, particlesMaterial);
scene.add(particles);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */
// Group
const cameraGroup = new THREE.Group();
scene.add(cameraGroup);

// Base camera
const camera = new THREE.PerspectiveCamera(
  35,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.z = 6;
cameraGroup.add(camera);

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: true,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Scroll
 */
let scrollY = window.scrollY;
let currentSection = 0;

window.addEventListener("scroll", () => {
  scrollY = window.scrollY;
  const newSection = Math.round(scrollY / sizes.height);
});

/**
 * Cursor
 */
const cursor = {};
cursor.x = 0;
cursor.y = 0;

window.addEventListener("mousemove", (event) => {
  cursor.x = event.clientX / sizes.width - 0.5;
  cursor.y = event.clientY / sizes.height - 0.5;
});

const dracoLoader = new DRACOLoader();
const gltfLoader = new GLTFLoader();
dracoLoader.setDecoderPath("/draco/");
gltfLoader.setDRACOLoader(dracoLoader);
console.log(gltfLoader);

gltfLoader.load("/models/cabine_exterieur.glb", (gltf) => {
  gltf.scene.scale.set(0.8, 0.8, 0.8);
  gltf.scene.position.set(2, -1, -2);
  gltf.scene.position.y = -objectsDistance * 0.3;
  scene.add(gltf.scene);
});

gltfLoader.load("/models/interieur_cabine.glb", (gltf) => {
  gltf.scene.scale.set(0.6, 0.6, 0.6);
  gltf.scene.position.set(-1.2, 2, 1);
  gltf.scene.rotation.y = -0.294;
  gltf.scene.position.y = -objectsDistance * 1.25;
  scene.add(gltf.scene);
  // gui
  //   .add(gltf.scene.rotation, "y")
  //   .min(-Math.PI)
  //   .max(Math.PI)
  //   .step(0.001)
  //   .name("rotationinterieur");
});

gltfLoader.load("/models/siege.glb", (gltf) => {
  gltf.scene.scale.set(2.8, 2.8, 2.8);
  gltf.scene.position.set(6, -2, -2);
  gltf.scene.rotation.y = 0.114;
  gltf.scene.position.y = -objectsDistance * 2.08;
  scene.add(gltf.scene);
  // gui
  //   .add(gltf.scene.rotation, "y")
  //   .min(-Math.PI)
  //   .max(Math.PI)
  //   .step(0.001)
  //   .name("rotation3");
  // scene.add(gltf.scene);
});

gltfLoader.load("/models/four.glb", (gltf) => {
  gltf.scene.scale.set(1.2, 1.2, 1.2);
  gltf.scene.position.set(0, -1, 0);
  gltf.scene.position.y = -objectsDistance * 3.08;
  gltf.scene.rotation.y = -2.8;
  // gui
  //   .add(gltf.scene.rotation, "y")
  //   .min(-Math.PI)
  //   .max(Math.PI)
  //   .step(0.001)
  //   .name("rotation");
  scene.add(gltf.scene);
});

gltfLoader.load("/models/four.glb", (gltf) => {
  gltf.scene.scale.set(1.2, 1.2, 1.2);
  gltf.scene.position.set(1.85, -1, 0);
  gltf.scene.position.y = -objectsDistance * 4.25;
  gltf.scene.rotation.y = 1.749;
  // gui
  //   .add(gltf.scene.rotation, "y")
  //   .min(-Math.PI)
  //   .max(Math.PI)
  //   .step(0.001)
  //   .name("rotation2");
  scene.add(gltf.scene);
});

gltfLoader.load("/models/urne.glb", (gltf) => {
  gltf.scene.scale.set(6, 6, 6);
  gltf.scene.position.set(14, 1, 1);
  gltf.scene.rotation.x = 0;
  gltf.scene.position.y = -objectsDistance * 5.1;
  scene.add(gltf.scene);
  // gui
  //   .add(gltf.scene.rotation, "y")
  //   .min(-Math.PI)
  //   .max(Math.PI)
  //   .step(0.001)
  //   .name("rotation2");
});

// gltfLoader.load("/models/tour.gltf", (gltf) => {
//   gltf.scene.scale.set(2, 2, 2);
//   gltf.scene.position.set(2, 2, 2);
//   gltf.scene.position.y = -objectsDistance * 6.1;
//   scene.add(gltf.scene);
//   // gui
//   //   .add(gltf.scene.rotation, "y")
//   //   .min(-Math.PI)
//   //   .max(Math.PI)
//   //   .step(0.001)
//   //   .name("rotation3");
// });
/**
 * Animate
 */
const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  // Animate camera
  camera.position.y = (-scrollY / sizes.height) * 4;

  const parallaxX = cursor.x * 0.5;
  const parallaxY = -cursor.y * 0.5;
  cameraGroup.position.x +=
    (parallaxX - cameraGroup.position.x) * 5 * deltaTime;
  cameraGroup.position.y +=
    (parallaxY - cameraGroup.position.y) * 5 * deltaTime;

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();

const ratio = 0.4;
const options = {
  root: null,
  rootMargin: "0px",
  threshold: ratio,
};

const handleIntersect = function (entries, observerText) {
  entries.forEach(function (entry) {
    if (entry.intersectionRatio > ratio) {
      entry.target.classList.add("slideInUp");
      observerText.unobserve(entry.target);
    }
  });
};

var observerText = new IntersectionObserver(handleIntersect, options);
document.querySelectorAll(".text_anim").forEach((r) => {
  observerText.observe(r);
});
